import { Button, Modal, Row, Space } from "antd";
import React, { useEffect, useRef, useState } from "react";
import markerImageTrukker from "../../assets/images/location-marker-image.svg";
import markerImageAdeed from "../../assets/adeed/images/location-marker-image.svg";
import downImg from "../../assets/images/down-arrow-icon.svg";
import LeftArrowTrukker from "../../assets/images/Arrow L.svg";
import LeftArrowAdeed from "../../assets/adeed/images/Arrow L.svg";
import rightArrowTrukker from "../../assets/images/Arrow R.svg";
import rightArrowAdeed from "../../assets/adeed/images/Arrow R.svg";
import "./map-view-modal.scss";
import { useNavigate } from "react-router-dom";
import { isAdeed, BrandColors, brandColor } from "../../constants/brand";

// ADEED Freight shows its blue copies of these images (src/assets/adeed).
const markerImage = isAdeed ? markerImageAdeed : markerImageTrukker;
const LeftArrow = isAdeed ? LeftArrowAdeed : LeftArrowTrukker;
const rightArrow = isAdeed ? rightArrowAdeed : rightArrowTrukker;

const CustomMapModal = ({ isOpen, setMapModalOpen, markers, typeData }) => {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const scrollContainerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const cardWidth = 300;
  const itemsPerPage = 3;
  const totalPages = Math.ceil(markers?.length / itemsPerPage);
  const currentMarkers = markers?.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);
  const [autoScroll, setAutoScroll] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!scrollContainerRef.current) return;
    scrollContainerRef.current.scrollLeft = currentPage * cardWidth;
  }, [currentPage]);


  useEffect(() => {
    if (!isOpen) return;
  
    const loadMap = () => {
      if (!window.google || !mapRef.current || mapInstance.current) return;
    
      mapInstance.current = new window.google.maps.Map(mapRef.current, {
        center: {
          lat: markers[0]?.currentLocation?.latitude || 25.06570000,
          lng: markers[0]?.currentLocation?.longitude || 55.17128000
        },
        zoom: markers.some(item => item?.currentLocation) ? 12 : 3,
        styles: [
          {
            featureType: "all",
            elementType: "geometry",
            stylers: [{ color: brandColor(BrandColors.primaryTint, "#F8F2E6") }]
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ color: "#d7ccc8" }]
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{ color: brandColor(BrandColors.primaryTint, "#F8F2E6") }]
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#AEE2FF" }]
          },
          {
            featureType: "transit",
            stylers: [{ visibility: "off" }]
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff"}, { weight: 1.2 }]
          },
          { 
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#D3D3D3" }] 
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }, { weight: 1.2 }]
          },
          { 
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#D3D3D3" }] 
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{ color: brandColor("#BBC8FA", "#F5E1A4") }]
          },
        ],
        mapTypeControl: false,
        scaleControl: false,
      });
  
      const bounds = new window.google.maps.LatLngBounds();
  
      if (markers.some(item => item?.currentLocation)) {
        markers.forEach((data) => {
          if (!data?.currentLocation) return;
  
          const position = new window.google.maps.LatLng(
            data.currentLocation.latitude,
            data.currentLocation.longitude
          );
  
          const marker = new window.google.maps.Marker({
            position,
            map: mapInstance.current,
            title: data?.title,
            icon: {
              url: markerImage,
              scaledSize: new window.google.maps.Size(50, 50),
            },
          });
  
          const infoWindow = new window.google.maps.InfoWindow({
            content: `<div><strong>${data?.title}</strong><br>${data.infoWindowContent}</div>`
          });
  
          marker.addListener("click", () => {
            infoWindow.open(mapInstance.current, marker);
          });
  
          bounds.extend(position);
        });
  
        mapInstance.current.fitBounds(bounds);
      }
    };
  
    if (window.google && window.google.maps) {
      loadMap();
    } else {
      const scriptId = "google-maps-script";
      if (!document.getElementById(scriptId)) {
        const script = document.createElement("script");
        script.id = scriptId;
        script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_GOOGLE_MAPS_API_KEY&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = loadMap;
        document.head.appendChild(script);
      } else {
        loadMap();
      }
    }
  }, [isOpen, markers]);
  

  
  const nextPage = () => {
    if (currentPage < markers.length - 1) {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollLeft += 300;
      }
    }
    if (currentPage < totalPages - 1) {
        setCurrentPage(currentPage + 1);
      }
  };
  
  const prevPage = () => {
    if (currentPage > 0) {
        setCurrentPage(currentPage - 1);
        if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollLeft -= 300;
      }
    }
  };
  function getStringBeforeComma(str) {
    const index = str?.indexOf(',');
    if (index !== -1) {
        return str.substring(0, index);
    }// If there's no comma, return the original string
  }

  return (
    <Modal
      title="Map View"
      open={isOpen} centered
      onCancel={() => setMapModalOpen(false)}
      footer={null}
      width={1000}
    >
        <div className="map-container">
            <div className="line"></div>
            <Row justify={'end'}>
                <Button>{typeData} <span className="marker-count">{markers?.length}</span> <img src={downImg} alt="" /></Button>
            </Row>
            <div className="map" ref={mapRef} />
            {markers?.length > 0 &&
              <div className="move-btn">
                  <img src={LeftArrow} alt="" onClick={prevPage} />
                  <img src={rightArrow} alt="" onClick={nextPage} />
              </div>
            }
            <div className="marquee-container"  ref={scrollContainerRef}>
                <div className="marquee-content">
                  {currentMarkers?.map((truck, index) => (
                    <div key={truck.id || index} className="truck-card">
                        <div className="truck-row">
                            <span className="span-row">
                                <span className="truck-color">Truck No:</span>
                                <span className="truck-span">{truck.assetPlateNumber}</span>
                            </span>
                            <span className="truck-type-span">{truck.truckType} - {truck.subTruckType}</span>
                        </div>
                        <Row justify={'space-between'} className="truck-row">
                            <span className="truck-color">Driver Name</span>
                            <span className="truck-color">Contact Number</span>
                        </Row>
                        <Row justify={'space-between'}>
                            <span className="type-span">{truck.driverName}</span>
                            <span className="type-span">{truck.countryCode} {truck.mobileNo}</span>
                        </Row>
                        <div className="line-divider"></div>
                        <Row justify={'space-between'}>
                            <span className="order-no" onClick={() => navigate(`/orders/${truck?.orderNumber}/${truck?.tripId}/${truck?.assetPlateNumber}-${truck?.driverName}`)} >{truck.orderNumber}</span>
                            <span className="status">{truck.tripStatus}</span>
                        </Row>
                        <Row justify={'space-between'}>
                            <span className="truck-color">From</span>
                            <span className="truck-color">To</span>
                        </Row>
                        <Row justify={'space-between'}>
                            <span className="type-span">{getStringBeforeComma(truck?.fromCity)}</span>
                            <span className="type-span">{getStringBeforeComma(truck?.toCity)}</span>
                        </Row>
                    </div>
                  ))}
                </div>
            </div>
            <div className="pagination-indicator">
                <span>{currentPage + markers?.length > 0 ? currentPage + 1 : 0} / {totalPages}</span>
            </div>
        </div>
    </Modal>
  );
};

export default CustomMapModal;
